import type {FC} from 'react';
import {GridActionsCellItem, Icon, IconNames} from '@wellstone-solutions/web';
import type {ContactNote} from 'api/v2';
import {useViewNoteDetails} from './NoteDetailsProvider';

type ViewDetailsActionProps = {
  note: ContactNote;
  // The grid reads this off the element to place it, so it must be a prop
  showInMenu: boolean;
};

export const ViewDetailsAction: FC<ViewDetailsActionProps> = ({
  note,
  showInMenu,
}) => {
  const viewDetails = useViewNoteDetails();

  return (
    <GridActionsCellItem
      label="View details"
      icon={<Icon name={IconNames.Eye} size={22} />}
      showInMenu={showInMenu}
      onClick={() => viewDetails(note)}
    />
  );
};
